import { Record } from 'immutable';

const CompanyMapRecord = Record({
  rows: [],
  headings: [],
  headingOptions: [],
});

export default class CompanyMap extends CompanyMapRecord {
  static deserialize(jsonObject = {}) {
    return new CompanyMap(jsonObject);
  }
}
